import { useEffect } from "react";

/**
 * Mounts only once ALL lazy siblings inside the same Suspense boundary have
 * resolved (Suspense renders its whole subtree together). Firing here means
 * every essential section chunk has loaded — the signal to dismiss the loader.
 */
export default function ReadySignal({ onReady }) {
  useEffect(() => {
    // Defer one frame so the sections commit/paint before we dismiss.
    const raf = requestAnimationFrame(() => onReady && onReady());
    return () => cancelAnimationFrame(raf);
  }, [onReady]);
  return null;
}
